import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, Input, OnInit, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb'; 
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { ThemeService } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-choose-property-admin-config',
  templateUrl: './choose-property-admin-config.component.html',
  styleUrls: ['./choose-property-admin-config.component.scss']
})
export class AtwChoosePropertyAdminConfig extends AtwUpdateDbComponent implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() blocks_of_page: any; // là dữ liệu blocks_of_page từ database

  currentViewAll: any = {}; // biến xác định mở rộng tất cả hay theo thuộc tính
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  valueRange: number = 0; // biến này tính giá trị của (input range / 100) để tính độ trong suốt
  valueParameter: number = 0; // biến này tính giá trị của (input range) để hiện thị giá trị ra màn hình
  style_color: string = '' // biến này lấy giá trị của màu rgb và alpha;

  backgroundColor: any = [];
  styles_field = [
    {
      title: 'dieu_chinh_noi_dung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien',
      index: 2,
    },
    {
      title: 'hieu_ung',
      index: 3,
    },
    {
      title: 'nang_cao',
      index: 4,
    },
    {
      title: 'nen_bieu_tuong',
      index: 5,
    },
  ];
  effect_hover = [];
  effect_hover_data: any = {}
  width = 0;
  height = 0;
  configMode: 'basic' | 'advanced' = 'basic';

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    public vhEventMediator: VhEventMediator,
    public themeService: ThemeService,
    @Inject(PLATFORM_ID) private platformId: Object,
    public functionService: FunctionService,
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }
  parserPercent = (value: string): string => value.replace('%', '');
  formatterPercent = (value: number): string => {
    return `${value} %`;
  };

  ngOnInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
    setTimeout(() => {
      if (isPlatformBrowser(this.platformId)) {
        this.width = document.getElementById(this.objectChoosing._id).clientWidth;
        this.height = document.getElementById(this.objectChoosing._id).clientHeight;
      }
    }, 0);
  }



  // /**
  // * Hàm update object vào database.
  // */
  // updateObject() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
  //     .then((bool: any) => {
  //       // console.log('updateObject', bool);
  //     })
  // }
  // /**
  // *Hàm update class vào database.
  // */
  // updateClass() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
  //     .then((bool: any) => {
  //       // console.log('updateClass', bool);
  //     })
  // }



  /**
  * hàm này để update width height trong dimention của config  
  */
  updateDimension() {
    if (isPlatformBrowser(this.platformId)) {
      this.width = document.getElementById(this.objectChoosing._id).clientWidth;
      this.height = document.getElementById(this.objectChoosing._id).clientHeight;
    }
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.config = {
      ...this.config,
      dimension: {
        width: Number(Number(this.width).toFixed(2)),
        height: Number(Number(this.height).toFixed(2))
      }
    }

    this.updateConfig()
  }
  /**
  *Hàm update config vào database.
  */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {
      })
  }


  /**
  * Cập nhật staticdata vào database.
  */
  updateStaticData() {
    // Gọi hàm truy vấn cơ sở dữ liệu ở đây
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {
      });
    this.updateDimension()
  }

  
  customize = []

  /**
  * Hàm này dùng để mở rộng phần cấu hình.
  * @param field_text : trả về phần tử được chọn của mảng style_field
  */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }


  /**
  * Hàm này dùng để cho phép mở menu config .
  * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
  * @param: value
  */
  openMap: { [name: string]: boolean } = {
    menu1: true, menu2: false, menu3: false, menu4: false, menu5: false, menu6: false, menu7: false, menu8: false
  };

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }


  /**
  * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
  * @param event width hieght của element sau khi thay đổi.
  * 
  * Nếu là text-align: left thì padding-left là phần configPaddingLeftRight, padding-right sẽ nhận toàn bộ phần padding còn lại, trừ đi configPaddingLeftRight; tương tự với trường hợp text-align: right.
  * Đối với text-align: center thì là padding / 2
  */
  changeWidthHeight(event) {
    if (event.width)
      this.class['choose-property']['width'] = event.width + 'px';
    if (event.height)
      this.class['choose-property']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
    this.updateClass();
  }

    /**
 *Hàm update class vào dabase, và gửi cập nhật width, height cho object-selected
  */
  updateClassAndWidthHeight() {
    if (isPlatformBrowser(this.platformId)) {
      this.width = document.getElementById(this.objectChoosing._id).clientWidth;
      this.height = document.getElementById(this.objectChoosing._id).clientHeight;
    }
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {
        // console.log('updateClassAndWidthHeight', bool);
      })
  }

  /**
  * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
  * @param event customize sau khi thay đổi
  */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[2])
  }

}
